import { Box, Heading, Text, VStack } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { HelpArticleDto } from '../hooks/useHelpArticles';
import { HelpCategoryWithCountDto } from '../hooks/useHelpCategories';

interface HelpSidebarProps {
  categories: HelpCategoryWithCountDto[];
  articles: HelpArticleDto[];
  currentSlug?: string;
  lang: string;
}

export default function HelpSidebar({ categories, articles, currentSlug, lang }: HelpSidebarProps) {
  const navigate = useNavigate();

  const getName = (cat: HelpCategoryWithCountDto) => lang === 'en' ? cat.nameEn : cat.nameFr;

  return (
    <Box as="nav" w={{ base: 'full', md: '260px' }} flexShrink={0}>
      <VStack align="stretch" spacing={4}>
        {categories.map((cat) => {
          const catArticles = articles.filter((a) => a.categoryId === cat.id);
          if (catArticles.length === 0) return null;

          return (
            <Box key={cat.id}>
              <Heading
                size="xs"
                textTransform="uppercase"
                color="gray.500"
                mb={2}
                cursor="pointer"
                onClick={() => navigate(`/marketing/help/${cat.slug}`)}
                _hover={{ color: 'brand.500' }}
              >
                {getName(cat)}
              </Heading>
              <VStack align="stretch" spacing={0} pl={2}>
                {catArticles.map((article) => (
                  <Text
                    key={article.id}
                    fontSize="sm"
                    py={1.5}
                    px={2}
                    borderRadius="md"
                    cursor="pointer"
                    bg={article.slug === currentSlug ? 'brand.50' : 'transparent'}
                    color={article.slug === currentSlug ? 'brand.600' : 'gray.700'}
                    fontWeight={article.slug === currentSlug ? 'semibold' : 'normal'}
                    _hover={{ bg: 'gray.50', color: 'brand.500' }}
                    onClick={() => navigate(`/marketing/help/${cat.slug}/${article.slug}`)}
                  >
                    {article.title}
                  </Text>
                ))}
              </VStack>
            </Box>
          );
        })}
      </VStack>
    </Box>
  );
}
